// extracted by mini-css-extract-plugin
export default {"root":"Link_root__mZQMt","disabled":"Link_disabled__RXTkv","string":"Link_string__80O39"};